import { ReactElement } from 'react';
import AuthenticatedRoute from '../../components/AuthenticatedRoute';
import { Outlet } from 'react-router';
import { TenantSettingsGate } from '../gates/TenantSettingsGate';

export const AuthenticatedLayout = (): ReactElement => {
  return (
    <AuthenticatedRoute>
      <TenantSettingsGate>
        <Outlet />
      </TenantSettingsGate>
    </AuthenticatedRoute>
  );
};
